import { createContext, useContext, useEffect, useState } from "react";
import BaseApi from "../services/base-api";
import { Category } from "../types/Category";

type CategoriesContextType = {
  categories: Category[];
  loading: boolean;
};

const CategoriesContext = createContext<CategoriesContextType>({
  categories: [],
  loading: true,
});

export const CategoriesProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    let mounted = true;

    const fetchCategories = async () => {
      try {
        const res = await BaseApi.get(
          `/categories?page=${currentPage}&limit=${itemsPerPage}`,
        );
        if (mounted) {
          setCategories(
            res.data.filter((category: Category) => !category.parentId),
          );
        }
      } catch (error) {
        console.error("Failed to fetch categories", error);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchCategories();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <CategoriesContext.Provider value={{ categories, loading }}>
      {children}
    </CategoriesContext.Provider>
  );
};

export const useCategories = () => useContext(CategoriesContext);
